import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useHistory, useParams } from 'react-router-dom'
import ActionButtonComponent from '../../../components/common/actionButton/ActionButtonComponent'
import fileNumberSequenceService from '../../../services/systemConfiguration/fileNumberSequence/fileNumberSequenceService'

const ViewFileNumberSequence = () => {
  const history = useHistory()
  const { id } = useParams() as any
  const [data, setData] = useState<any>(null)

  useEffect(() => {
    async function load() {
      const resp = await fileNumberSequenceService.apiGetById(parseInt(id))
      setData(resp.data)
    }
    load()
  }, [id])

  return (
    <>
      <Row className="title-layout">
        <Col className="d-flex justify-content-start">
          <span className="m-2">File Number Sequence</span>
        </Col>
      </Row>

      <Row className="role-and-permission-body-layout mt-4">
        <Col sm={12} className="d-flex justify-content-end">
          <ActionButtonComponent name="Modify" routeURL={`../modify/${id}`} />
          <button
            type="button"
            className="btn btn-secondary ms-2"
            onClick={() => history.goBack()}
          >
            Back
          </button>
        </Col>

        <Col sm={12} className="mt-3">
          {data ? (
            <div className="border-label p-3">
              <div>
                <b>Scheme</b>: {data.scheme}
              </div>
              <div>
                <b>District Number</b>: {data.districtNumber}
              </div>
              <div>
                <b>Scheme Max Number</b>: {data.schemeMaxNumber}
              </div>
              <div>
                <b>District Max Number</b>: {data.districtMaxNumber}
              </div>
              <div>
                <b>File Number Max</b>: {data.fileNumberMaxNumber}
              </div>
            </div>
          ) : (
            ''
          )}
        </Col>
      </Row>
    </>
  )
}

export default ViewFileNumberSequence
